import GetKeyStats from "./GetKeyStats";
import CreateBeneficiary from "./CreateBeneficiary";

const IFA = {
	GetKeyStats,
	CreateBeneficiary,
};

export default IFA;